// Header section for ticket entry page
import React from 'react';
import styles from '../css/hero.module.css';
import { useNavigate } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';

export default function HeroTicketEntry({
  openCheckOut,
  title,
  isBtnVisible,
  btnCaption,
  btnIcon,
  findOmittedTicket,
  uncheckedInTickets,
}) {
  const navigate = useNavigate();
  return (
    <div className={styles.heroContainer}>
      <div className={styles.cautionDiv}>
        <h3 className={styles.cautionMessage}>
          Click{' '}
          <a
            style={{ fontSize: '20px' }}
            href="/"
            onClick={() => {
              uncheckedInTickets();
            }}
          >
            here
          </a>{' '}
          or{' '}
          <a
            href="##"
            onClick={async () => {
              await uncheckedInTickets();
              navigate('/');
            }}
          >
            {' '}
            Home
          </a>{' '}
          button below to go back to the home screen if you arrived here while checking out a ticket.
        </h3>
        <h3 className={styles.cautionMessage}>
          This page is for checking in tickets or updating ticket location and/or vehicle information only.
        </h3>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
        <h1 className={styles.topHeader}>{title}</h1>

        <button
          onClick={async () => {
            await uncheckedInTickets();
            navigate('/');
          }}
          className={styles.checkOutBtn}
        >
          <FaHome
            style={{
              marginRight: '8px',
            }}
          />
          Home
        </button>
      </div>

      {/* <ActivitiesTable /> */}

      {/* <button
        className={styles.checkOutBtn}
        type="button"
        onClick={() => {
          openCheckOut();
        }}
        style={{
          visibility: isBtnVisible ? 'visible' : 'hidden',
        }}
      >
        {btnIcon} {btnCaption}
      </button> */}
    </div>
  );
}
